import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const FILTER_KEY = 'quick_filter_discount';

export const useQuickFilterSectionDiscountOpenedState = () => {
  return useOpenedStateManager(FILTER_KEY);
};
